import React from "react";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { fetchAggregatorCategories } from "../../queries/aggregator/aggregatorQuery";
import api from "../../utils/api";
class NewAccount extends React.Component {
  state = {
    error: {},
    name: "",
    email: "",
    phoneNumber: "",
    isSubmitting: false,
    categories: [],
    status: {
      label: "Active",
      value: true,
    },
    activeBanks: [],
    accountName: "",
    location: "",
  };

  componentDidMount = async () => {
    await this.getCategories(true);

    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  };

  getCategories = async (isLoadingCategory) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoadingCategory });

      const categories = await fetchAggregatorCategories(defaultLanguage, {
        listType: "dropdown",
        active: true,
      });

      this.setState({
        categories,
        isLoadingCategory: false,
      });
    } catch (error) {
      this.setState({ isLoadingCategory: false });
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });

    if (field === "channel") {
      this.getActiveBanks(true, e.value);
    }
  }

  validateForm() {
    let { error, category, name, location } = this.state;

    if (!category) {
      error.category = language[this.props.defaultLanguage].category_required;
    }

    if (name === "") {
      error.name = language[this.props.defaultLanguage].name_required;
    }

    if (location === "") {
      error.location = language[this.props.defaultLanguage].location_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, name, category, location } = this.state;
    const { id } = this.props;

    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("core")}/aggregator`,
        data: {
          categoryId: category.value,
          name,
          aggregatorId: "",
          location,
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "aggregator_update_success"
                : "aggregator_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "error",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "aggregator_update_error"
                : "aggregator_add_error"
            ]
          );
        });
    }
  };

  render() {
    return (
      <>
        <div className="card-body">
          <Select
            options={this.state.categories}
            label={language[this.props.defaultLanguage].category}
            placeholder={language[this.props.defaultLanguage].select}
            value={this.state.category}
            onChange={(e) => this.onChangeInput("category", e)}
            error={this.state.error.category}
            isLoading={this.state.isLoadingCategory}
          />
          <Input
            label={language[this.props.defaultLanguage].name}
            placeholder={language[this.props.defaultLanguage].name_placeholder}
            value={this.state.name}
            onChange={(e) => this.onChangeInput("name", e)}
            error={this.state.error.name}
          />
          <Input
            label={language[this.props.defaultLanguage].location}
            placeholder={
              language[this.props.defaultLanguage].location_placeholder
            }
            value={this.state.location}
            onChange={(e) => this.onChangeInput("location", e)}
            error={this.state.error.location}
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewAccount);
